import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { shippingModal as messages } from '../shippingMessages';

// styles
import styles from './ShippingDetailsAddress.scss';

// helpers
import get from 'lodash.get';

export function ShippingDetailsAddressComponent({ item }) {
    const address = get(item, 'address.itemAddress');

    // check dealer preferences about showing the store address
    if (!address) {
        return null;
    }

    return <p className={styles.address}>{messages.shipsFrom(address)}</p>;
}

ShippingDetailsAddressComponent.propTypes = {
    item: PropTypes.object,
};

export const ShippingDetailsAddress = createFragmentContainer(ShippingDetailsAddressComponent, {
    item: graphql`
        fragment ShippingDetailsAddress_item on Item {
            address {
                itemAddress: displayCityStateCountry(fullCountryName: true)
            }
        }
    `,
});
